<!--
 * @Author: Junjie
 * @Date: 2022-11-19 14:03:45
 * @LastEditTime: 2022-11-21 11:23:25
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/jeecg/report/online/SubmitReport.vue
-->
<template>
  <div class="page-container">
    <div class="flex h-full">
      <div class="overflow-y-scroll">
        <common-category-tree :collapsed.sync="treeCollapsed" :pCode="categoryRootCode" @change="onSelect"></common-category-tree>
      </div>
      <div :class="['pl-20px',treeCollapsed?'edit-table-collapsed':'edit-table-full']">
        <template v-if="reportPageType">
          <iframe-f-report-view
            :src="iframeSrc"
            allowfullscreen="true"
            frameborder="0"
            mozallowfullscreen="true"
            msallowfullscreen="true"
            oallowfullscreen="true"
            ref="commentIframe"
            v-if="reportPageType=='outside'"
            webkitallowfullscreen="true"
          ></iframe-f-report-view>
          <route-view v-if="reportPageType=='inside'&&routerCode" />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';
  import { mixinDevice } from '@/utils/mixin.js';
  import { getAction } from '@/api/manage';
  import onlineCommons from '@jeecg/antd-online-mini'
  import RouteView from '@/components/layouts/RouteView.vue'
  import CommonCategoryTree from "./modules/CommonCategoryTree";
  const ReportItem = onlineCommons.onlineCommon
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      IframeFReportView, onlineCommons, RouteView, ReportItem, CommonCategoryTree
    },
    mixins: [mixinDevice],
    data () {
      return {
        name: 'SubmitReport',
        iframeSrc: '',
        mainInfoHeight: "100%",
        title: '',
        categoryRootCode: 'A01',
        treeCollapsed: false,
        reportPageType: '',
        defaultExpandedKeys: [],
        autoExpandParent: true,
        expandAll: false,
        defaultSelectedKeys: [],
      }
    },
    created () {
    },
    mounted () {
      //   this.mainInfoHeight = (window.innerHeight - 285) + "px";
    },
    computed: {
      ...mapGetters(['permissionList']),

      routerCode () {
        return this.$route.params.code || 0
      }
    },

    methods: {
      onSelect (treeNode) {
        const url = treeNode.dataRef.cusProp1;
        if (treeNode.dataRef.pid == "0" || !url) {
          return;
        }
        this.selectUrl(treeNode.dataRef);
      },
      selectUrl (treeNode) {
        const url = treeNode.cusProp1;
        this.iframeSrc = url;
        this.title = treeNode.name;
        const reportPageType = url.indexOf('http') !== -1 ? 'outside' : 'inside'
        this.reportPageType = reportPageType
        if (reportPageType == 'inside') {
          this.$router.push({
            path: this.iframeSrc
          })
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .edit-table {
    &-collapsed {
      width: calc(100% - 50px);
    }
    &-full {
      width: calc(100% - 308px);
    }
  }
</style>